/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Input } from 'reactstrap';
import { BaseInputProps } from './InputProps';
import { TextAreaWithAIDraft } from '../../../../apps/common/components/TextAreaWithAIDraft/TextAreaWithAiDraft';
import G17Client from '../../../../services/G17Client';

interface textInputProps extends Pick<BaseInputProps, 'isDisabled' | 'universalTracker' | 'valueDataData' | 'handleFocus' | 'handleValueDataChange' | 'placeholder'> {
  valueDataData: any
}

export default function TextInput(props: textInputProps) {
  const {
    isDisabled,
    universalTracker,
    valueDataData,
    handleFocus,
    handleValueDataChange,
    placeholder
  } = props;

  const defaultValue = valueDataData === undefined ? '' : valueDataData;

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    e.preventDefault();
    return handleValueDataChange(e.target.value);
  };

  const disabled = isDisabled?.(props);
  const maxLength = universalTracker.getMax();
  const utrId = universalTracker.getId();
  if (maxLength && maxLength > 1 && maxLength < 100) {
    return <div className='input-group mb-3'>
      <Input
        autoComplete='off'
        type='text'
        className='styled-input'
        name={utrId}
        value={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        required={true}
        onFocus={handleFocus}
        onClick={handleFocus}
        onChange={onChange} />
    </div>
  } else {
    return <div className='input-group mb-3'>
      <TextAreaWithAIDraft
        key={`inputfactor-textarea-ai-${utrId}`}
        rows={5}
        className='styled-input'
        name={utrId}
        value={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        required={true}
        onFocus={handleFocus}
        onClick={handleFocus}
        onChange={handleValueDataChange}
        getDraft={() => G17Client.getQuestionInputFieldDraft({ utrId })
        }
      />
    </div>
  }
}
